<!-- <p-table [value]="products" #dt [globalFilterFields]="['email','username','server','port']">
    <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
            </span>
            <p-button icon="pi pi-plus" (click)="newServer()"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Email ID</th>
            <th>Username</th>
            <th>SMTP Server</th>
            <th>Port</th>
            <th>Is Default</th>
            <th>Is Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.email}}</td>
            <td>{{product.username}}</td>
            <td>{{product.server}}</td>
            <td>{{product.port}}</td>
            <td>
                <p-radioButton [disabled]="!product.isActive" [value]="true" [(ngModel)]="product.isDefault"
                  (onClick)="eventCalled(product)"></p-radioButton>
                  <span *ngIf="product?.isDefault"> Yes</span>
                  <span *ngIf="!product?.isDefault"> No</span>
            </td>
            <td>
                <span *ngIf="product?.isActive">Yes</span>
                <span *ngIf="!product?.isActive">No</span>
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editServer(product)"
                tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table> -->

<p-table [value]="vendorRegistrations" #dt [globalFilterFields]="['email','username','server','port']">
    <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <!-- <input pInputText type="text"  (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." /> -->
                <input pInputText type="text" [(ngModel)]="globalFilterInput" [ngModelOptions]="{ standalone: true }" (input)="onGlobalSearch()" placeholder="Search..." />
            </span>
            <p-button icon="pi pi-plus" (click)="newServer()"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Email ID</th>
            <th>Username</th>
            <th>SMTP Server</th>
            <th>Port</th>
            <th>Is Default</th>
            <th>Is Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-vRegistration>
        <tr>
            <td>{{vRegistration?.emailId}}</td>
            <td>{{vRegistration?.userName}}</td>
            <td>{{vRegistration?.serverName}}</td>
            <td>{{vRegistration?.serverPortOut}}</td>
            <td>
                <p-radioButton [disabled]="!vRegistration?.isValid" [value]="true" [(ngModel)]="vRegistration.isDefault"
                  (onClick)="eventCalled(vRegistration)"></p-radioButton>
                  <span *ngIf="vRegistration?.isDefault"> Yes</span>
                  <span *ngIf="!vRegistration?.isDefault"> No</span>
            </td>
            <td>
                <span>{{vRegistration?.statusId == 1 ? 'Yes' : 'No'}}</span>
                <!-- <span *ngIf="!vRegistration?.isValid">No</span> -->
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editServer1(vRegistration)"
                tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" pTooltip="Delete" (click)="deleteServer(vRegistration)" *ngIf="vRegistration?.createdSource != 'system' && !vRegistration?.isDefault"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Configure SMTP Mail Server" [(visible)]="displaySelectServer" [modal]="true" [responsive]="true"
  [style]="{width: '40vw'}">
  <div class="card">
    <div class="p-field p-formgrid p-grid">
        <!-- <div class="p-col-6 p-md-3">
            <p-card class="card-box">
                <div class="cursor-pointer" (click)="configureEmail({'id': '2'})">
                    <img src="https://d2pawxljps4e1j.cloudfront.net/SF2StaticLive/Content/image/mailserver/gmailserver.png" alt="gmail" >
                    <div class="p-text-center">Gmail SMTP</div>
                </div>
            </p-card>
        </div>  -->
        <!-- <div class="p-col-6 p-md-3">
            <p-card class="card-box">
                <div class="cursor-pointer" (click)="configureEmail({'id': '1'})">
                    <img src="https://d2pawxljps4e1j.cloudfront.net/SF2StaticLive/Content/image/mailserver/office365server.png" alt="office365" >
                    <div class="p-text-center">Office365 SMTP</div>
                </div>
            </p-card>
        </div> -->
        <div class="p-col-6 p-md-6">
            <p-card class="card-box">
                <div class="cursor-pointer" (click)="addServer('AWS')">
                    <img src="https://d2pawxljps4e1j.cloudfront.net/SF2StaticLive/Content/image/mailserver/awsserver.png" alt="aws" >
                    <div class="p-text-center">AWS SES SMTP</div>
                </div>
            </p-card>
        </div>
        <div class="p-col-6 p-md-6">
            <p-card class="card-box">
                <div class="cursor-pointer" (click)="addServer('others')">
                    <img src="https://d2pawxljps4e1j.cloudfront.net/SF2StaticLive/Content/image/mailserver/otherserver.png" alt="others" >
                    <div class="p-text-center">Others SMTP</div>
                </div>
            </p-card>
        </div>
    </div>
  </div>
</p-dialog>

<div *ngIf="dialogType">
<app-smtp-add-edit [serverHeader]="serverHeader" [type]="dialogType" [showOthers]="showOthers" [smtpVendorId]="vendorSMTPData" [vendorDetails]="vendorDetails" [displayAddEditServer]="displayAddEditServer" (onSaveComplete)="onSaveComplete($event)"
(onCancelClicked)="onCancelClicked($event)"></app-smtp-add-edit>
</div>



<!-- <p-dialog header="{{serverHeader}}" [(visible)]="displayAddEditServer" [modal]="true" [responsive]="true"
  [style]="{width: '55vw'}">
  <div class="header">
    <h5>Server Information
        <p-inputSwitch class="header-switch" [(ngModel)]="serverTemp.isActive"></p-inputSwitch>
    </h5>
  </div>
  <div class="card">
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
            <label>SMTP Server <span style="color: red;">*</span></label>
            <input type="text" pInputText placeholder="Enter SMTP Server" [(ngModel)]="serverTemp.server">
        </div>
        <div class="p-col-12 p-md-6" *ngIf="showOthers">
            <label>Username <span style="color: red;">*</span></label>
            <input type="text" pInputText placeholder="Enter Username" [(ngModel)]="serverTemp.username">
        </div>
        <div class="p-col-4 p-md-2" *ngIf="!showOthers">
            <label>Port</label>
            <input type="text" pInputText placeholder="Enter Port" [(ngModel)]="serverTemp.port">
        </div>
        <div class="p-col-8 p-md-4" *ngIf="!showOthers">
            <label>Username <span style="color: red;">*</span></label>
            <input type="text" pInputText placeholder="Enter Username" [(ngModel)]="serverTemp.username">
        </div>
    </div>
  </div>
  <div class="header">
    <h5>Email Information</h5>
  </div>
  <div class="card">
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
            <label>Email ID <span style="color: red;">*</span></label>
            <input type="text" pInputText placeholder="Enter Email ID" [(ngModel)]="serverTemp.email">
        </div>
        <div class="p-col-12 p-md-6">
            <label>Password <span style="color: red;">*</span></label>
            <input type="text" pInputText placeholder="Enter Password" [(ngModel)]="serverTemp.password">
        </div>
    </div>
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
            <label>Cc</label>
            <input type="text" pInputText placeholder="Enter Email ID" [(ngModel)]="serverTemp.cc">
            <div>(Use comma(,) sign to enter multiple email id.)</div>
        </div>
        <div class="p-col-12 p-md-6">
            <label>Bcc</label>
            <input type="text" pInputText placeholder="Enter Email ID" [(ngModel)]="serverTemp.bcc">
            <div>(Use comma(,) sign to enter multiple email id.)</div>
        </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayAddEditServer=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog> -->